module.exports = __webpack_public_path__ + "static/img/ls5.9e7a7ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/ls5.png
// module id = iVvi
// module chunks = 12